<template>
	<div>
		<el-card class="box-card">
			<div style="padding:-20px">
				<el-breadcrumb separator="/">
					<el-breadcrumb-item :to="{ path: '/home/index' }">首页</el-breadcrumb-item>
					<el-breadcrumb-item>系统管理</el-breadcrumb-item>
					<el-breadcrumb-item>用户管理</el-breadcrumb-item>
				</el-breadcrumb>
			</div>
		</el-card>
		
		<el-card class="box-card mainPadding" >
			<el-form :inline="true" :model="form" class="demo-form-inline" size="mini">
				<el-form-item label="账号">
					<el-input v-model="form.account" placeholder="账号"></el-input>
				</el-form-item>
				<el-form-item label="用户名">
					<el-input v-model="form.userName" placeholder="用户名"></el-input>
				</el-form-item>
				<el-form-item label="角色">
					<el-input v-model="form.role" placeholder="角色"></el-input>
				</el-form-item>
				<el-form-item>
					<el-button type="primary" @click="getData()" icon="el-icon-search">查询</el-button>
				</el-form-item>
				<el-form-item>
					<el-button type="primary" @click="add()" icon="el-icon-plus">添加</el-button>
				</el-form-item>
				<el-form-item>
					<el-button type="danger" @click="Batchdel()" icon="el-icon-delete">删除</el-button>
				</el-form-item>
			</el-form>
			<el-table :data="tableData" stripe style="width: 100%" ref="multipleTable" @selection-change="handleSelectionChange">
				<el-table-column type="index" label="#">
				</el-table-column>
				<el-table-column type="selection" width="55">
				</el-table-column>
				<el-table-column prop="account" label="账号">
				</el-table-column>
				<el-table-column prop="userName" label="用户名">
				</el-table-column>
				<el-table-column prop="role" label="角色">
				</el-table-column>
				<el-table-column prop="status" label="用户状态">
					<template slot-scope="scope">
						<el-switch v-model="scope.row.status" active-color="#13ce66" inactive-color="#dcdfe6" disabled>
						</el-switch>
					</template>
				</el-table-column>
				<el-table-column prop="loginDate" label="最后登录时间">
				</el-table-column>

				<el-table-column label="操作">
					<template slot-scope="scope">
						<el-button type="primary" icon="el-icon-edit" size="mini" @click="edit(scope.$index,scope.row)"></el-button>
						<el-button type="danger" icon="el-icon-delete" size="mini" @click="del(scope.$index,scope.row)"></el-button>
					</template>
				</el-table-column>
			</el-table>
			<el-pagination @size-change="handleSizeChange" @current-change="handleCurrentChange" :current-page="currentPage4" :page-sizes="[10, 20, 30, 50]" :page-size="100" layout="total, prev, pager, next, jumper" :total="10">
			</el-pagination>
		</el-card>

		<!--添加弹窗-->
		<el-dialog :title="title" :visible.sync="dialogAddFormVisible" width="35%">
			<el-form :model="addForm" size="small" label-width="80px" :rules="rules">
				<el-form-item label="账号" prop="account">
					<el-input v-model="addForm.account" autocomplete="off"></el-input>
				</el-form-item>
				<el-form-item label="用户名" prop="userName">
					<el-input v-model="addForm.userName" autocomplete="off"></el-input>
				</el-form-item>
				<el-form-item label="角色" prop="role">
					<el-select v-model="form.role" placeholder="请选择">
						<el-option v-for="(item,index) in roleList" :key="item.id" :label="item.user" :value="item.id">
						</el-option>
					</el-select>
				</el-form-item>
				<el-form-item label="用户状态" prop="status">
					<el-switch v-model="addForm.status" active-color="#13ce66" inactive-color="#dcdfe6">
					</el-switch>
				</el-form-item>
			</el-form>
			<div slot="footer" class="dialog-footer">
				<el-button @click="dialogAddFormVisible = false" size="mini">取 消</el-button>
				<el-button type="primary" @click="dialogAddFormVisible = false" size="mini">确 定</el-button>
			</div>
		</el-dialog>
	</div>
</template>

<script>
	export default {
		data() {
			return {
				//表格
				tableData: [{
						role: '管理员',
						account: '123',
						userName: '肖战',
						loginDate: '2020-02-02',
						status: true
					},
					{
						role: '普通用户',
						account: '666',
						userName: '钟汉良',
						loginDate: '2020-02-028',
						status: false
					}
				],
				//查询表单
				form: {
					role: [],
					account: '',
					userName: '',
					status: false
				},
				//角色列表
				roleList: [{
						id: '1',
						user: '管理员'
					},
					{
						id: '2',
						user: '普通用户'
					}
				],
				//添加表单
				addForm: {
					role: '',
					account: '',
					userName: '',
					status:''
				},
				//添加弹窗
				dialogAddFormVisible: false,
				rules: {
					role: [{
						required: true,
						message: '请输入角色',
						trigger: 'blur'
					}],
					account: [{
						required: true,
						message: '请输入账户',
						trigger: 'blur'
					}],
					userName: [{
						required: true,
						message: '请输入角色',
						trigger: 'blur'
					}],
				},
				//弹窗标题
				title: '',
				//选择的表格数据
				multipleSelection: [],
				//分页
				currentPage4: 4

			}
		},
		created() {},
		methods: {
			//获取表格数据
			getData() {
				alert('getData')

			},
			//删除
			del(index,row) {
				this.$confirm('是否删除用户名' + row.userName, '提示', {
					confirmButtonText: '确定',
					cancelButtonText: '取消',
					type: 'warning'
				}).then(() => {
					this.$message({
						type: 'success',
						message: '删除成功!'
					});
				}).catch(() => {
					this.$message({
						type: 'info',
						message: '已取消删除'
					});
				});
			},
			//编辑
			edit(index, row) {
				this.dialogAddFormVisible = true;
				this.title = '编辑';
				this.addForm.role = row.role;
				this.addForm.account = row.account;
				this.addForm.userName = row.userName;
			},
			//权限
			jur() {
				this.dialogqxFormVisible = true
			},
			//添加
			add() {
				this.title = '添加';
				this.addForm.role = '';
				this.addForm.userName = '';
				this.addForm.account = '';
				this.dialogAddFormVisible = true

			},
			//批量删除
			Batchdel() {
				if(this.multipleSelection.length > 0) {
					this.$confirm('是否删除这' + this.multipleSelection.length + '条数据！', '提示', {
						confirmButtonText: '确定',
						cancelButtonText: '取消',
						type: 'warning'
					}).then(() => {
						this.$message({
							type: 'success',
							message: '删除成功!'
						});
					}).catch(() => {
						this.$message({
							type: 'info',
							message: '已取消删除'
						});
					});
				} else {
					this.$message.error({
						message: '请选择要删除的数据！',
						type: 'none'
					});
				}
			},
			//获取选中的数据
			handleSelectionChange(val) {
				this.multipleSelection = val;
			},
			//翻页方法
			handleSizeChange(val) {
				console.log(`每页 ${val} 条`);
			},
			handleCurrentChange(val) {
				console.log(`当前页: ${val}`);
			}

		}
	}
</script>

<style>

</style>


// WEBPACK FOOTER //
// src/components/system/user.vue